import { useEffect, useState } from 'react';
import { FieldErrors, UseFormSetError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OTHER_DISCIPLINE } from 'corporate/constants';
import { useGetDisciplines } from 'corporate/hooks';
import { IDiscipline } from 'corporate/types';
import { IRequestJobs } from 'support/types';

import DisciplineCheckboxesView from './DisciplineCheckboxesView';

interface IProps {
  existingDisciplines?: { [disciplineId: number | string]: string };
  errors: FieldErrors<IRequestJobs>;
  setError: UseFormSetError<IRequestJobs>;
  onAddJob: (discipline: IDiscipline) => void;
  onRemoveJob: (discipline: IDiscipline) => void;
}

const DisciplineCheckboxes = ({
  existingDisciplines,
  errors,
  setError,
  onAddJob,
  onRemoveJob,
}: IProps) => {
  const [otherDiscipline, setOtherDiscipline] = useState<IDiscipline | null>(null);
  const [otherDisciplineChecked, setOtherDisciplineChecked] = useState<boolean>(false);
  const [disciplineList, setDisciplineList] = useState<IDiscipline[]>([]);

  const { t } = useTranslation();
  const { records: disciplines, isLoading, isError } = useGetDisciplines();

  useEffect(() => {
    setDisciplineList([
      ...disciplines,
      {
        name: t('labelOther'),
      },
    ]);
  }, [disciplines.length]);

  useEffect(() => {
    if (existingDisciplines && existingDisciplines?.[OTHER_DISCIPLINE]) {
      setOtherDisciplineChecked(true);
      setOtherDiscipline({
        name: existingDisciplines?.[OTHER_DISCIPLINE],
      });
    }
  }, [existingDisciplines]);

  const onChange = (checked: boolean, discipline: IDiscipline) => {
    setError('jobs', null);

    if (!discipline.id) {
      setOtherDisciplineChecked(checked);
    }

    if (checked) {
      onAddJob(discipline);

      return;
    }

    onRemoveJob(discipline);
  };

  return (
    <DisciplineCheckboxesView
      disciplines={disciplineList}
      otherDiscipline={otherDiscipline}
      setOtherDiscipline={setOtherDiscipline}
      otherDisciplineChecked={otherDisciplineChecked}
      existingDisciplines={existingDisciplines}
      onChange={onChange}
      error={errors?.jobs?.message || ''}
      isLoading={isLoading}
      isError={isError}
      loaderMinHeight={250}
    />
  );
};

export default DisciplineCheckboxes;
